import { render, staticRenderFns } from "./VesselParticularsValuation.vue?vue&type=template&id=3201d112&scoped=true&"
import script from "./VesselParticularsValuation.vue?vue&type=script&lang=js&"
export * from "./VesselParticularsValuation.vue?vue&type=script&lang=js&"
import style0 from "./VesselParticularsValuation.vue?vue&type=style&index=0&id=3201d112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201d112",
  null
  
)

export default component.exports